import { render, staticRenderFns } from "./RoleListSearchBox.vue?vue&type=template&id=24e89a0d&scoped=true&"
import script from "./RoleListSearchBox.vue?vue&type=script&lang=js&"
export * from "./RoleListSearchBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e89a0d",
  null
  
)

export default component.exports